import React from 'react'
import { Link } from 'react-router-dom'

export const ItemsDesplegables = ({url, text}) => {
    return (
        <Link  to={url}   className="items-despegables">
            <p>{text}</p>
            <img className="ml-half" src="/images/icons/small.svg" />
        </Link>
        
    )
}
